import { render, staticRenderFns } from "./VoiceSettings.vue?vue&type=template&id=1bcfd3e0&scoped=true"
import script from "./VoiceSettings.vue?vue&type=script&lang=js"
export * from "./VoiceSettings.vue?vue&type=script&lang=js"
import style0 from "./VoiceSettings.vue?vue&type=style&index=0&id=1bcfd3e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfd3e0",
  null
  
)

export default component.exports